var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/monitor-recorder"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor-recorder"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M45.8334 24.7708V26.625C45.8334 34.0417 43.9792 35.875 36.5834 35.875H13.4167C6.02092 35.875 4.16675 34.0208 4.16675 26.625V13.4167C4.16675 6.02084 6.02092 4.16667 13.4167 4.16667H16.6667",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25 35.875V45.8333",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.16675 27.0833H45.8334",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.625 45.8333H34.375",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M37.2083 19.5208H27.2916C24.4166 19.5208 23.4583 17.6042 23.4583 15.6875V8.35417C23.4583 6.0625 25.3333 4.1875 27.6249 4.1875H37.2083C39.3333 4.1875 41.0416 5.89583 41.0416 8.02083V15.6875C41.0416 17.8125 39.3333 19.5208 37.2083 19.5208Z",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M43.5626 16.5L41.0417 14.7292V8.97917L43.5626 7.20834C44.8126 6.35417 45.8334 6.875 45.8334 8.39584V15.3333C45.8334 16.8542 44.8126 17.375 43.5626 16.5Z",
    stroke: "#083844",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorIcon);
export default __webpack_public_path__ + "static/media/monitor-icon.b8cb7ae18b762f25303cb78928654e40.svg";
export { ForwardRef as ReactComponent };